const HOURS_IN_DAY = 24
const HOURS_IN_WEEK = 168
const MS_IN_HOUR = 1000 * 60 * 60

const DAYS_2_WEEKS = 14
const DAYS_3_WEEKS = 21
const DAYS_1_MONTH = 30

export const TOP_MATCH_THRESHOLD = 75

interface ActivityBadge {
  label: string
  isRecent: boolean
}

const DAILY_ACTIVITY_LABELS = [
  'Active today',
  'Active yesterday',
  'Active 2 days ago',
  'Active 3 days ago',
  'Active 4 days ago',
  'Active 5 days ago',
  'Active 6 days ago',
]

const WEEKLY_ACTIVITY_LABELS = [
  {
    maxDays: DAYS_2_WEEKS,
    label: 'Active 1 week ago',
  },
  {
    maxDays: DAYS_3_WEEKS,
    label: 'Active 2 weeks ago',
  },
  {
    maxDays: DAYS_1_MONTH,
    label: 'Active 3 weeks ago',
  },
]

const getHoursDiff = (date: string | Date): number =>
  (Date.now() - new Date(date).getTime()) / MS_IN_HOUR

export const getActivityBadge = (
  lastActivity: string | Date,
): ActivityBadge => {
  const hours = getHoursDiff(lastActivity)

  if (hours < HOURS_IN_WEEK) {
    return {
      label: DAILY_ACTIVITY_LABELS[Math.floor(hours / HOURS_IN_DAY)],
      isRecent: true,
    }
  }

  const days = hours / HOURS_IN_DAY
  const weeklyLabel = WEEKLY_ACTIVITY_LABELS.find(
    ({ maxDays }) => days < maxDays,
  )

  return {
    label: weeklyLabel?.label ?? 'Active 1+ month ago',
    isRecent: false,
  }
}

const getShowTopMatch = (matchingPercent?: number): boolean =>
  typeof matchingPercent === 'number' && matchingPercent >= TOP_MATCH_THRESHOLD

interface BadgesBlockData {
  showTopMatch: boolean
  activityBadge: ActivityBadge | null
  hasAnyBadge: boolean
}

export const getBadgesData = (
  matchingPercent?: number,
  madePlacements?: boolean,
  isSaved?: boolean,
  lastActivity?: string | Date,
): BadgesBlockData => {
  const showTopMatch = getShowTopMatch(matchingPercent)
  const activityBadge = lastActivity ? getActivityBadge(lastActivity) : null
  const hasAnyBadge =
    showTopMatch ||
    Boolean(madePlacements) ||
    Boolean(isSaved) ||
    Boolean(activityBadge)

  return { showTopMatch, activityBadge, hasAnyBadge }
}
